export enum SelectStatementType {
  ALL = 'ALL',
  COUNT = 'COUNT',
  ATTRITION = 'ATTRITION',
}

export type CohortTranslation = {
  sqlQuery: string;
  selectStmtType: SelectStatementType;
  /**
   * Set when the cohort definition contains AV criteria that reference a
   * library AV (via `sourceLibraryAvId`) without a matching local entry in
   * `analyticalVariables`. The backend short-circuits the compile and
   * returns HTTP 200 with an empty `sqlQuery` instead of raising. The FE
   * uses this flag to render an "incomplete" SQL placeholder and gate the
   * Run-cohort button — save remains untouched. See OR-6067 and the
   * decoupling note in `useCohortTranslationQuery`.
   */
  hasUnresolvedRefs?: boolean;
};
